import endpoints from "../../lib/endpoints";
import getRequest from "../../lib/fetchClient";
import { baseUrl, buildPaginationQuery } from "../../lib/util";

export const fetchFilteredCourses = async (type = "", searchParams, params) => {
  try {
    if (searchParams?.query) {
      const query = new URLSearchParams({
        query: searchParams.query.trim(),
        start: String(searchParams?.start || 0),
        limit: String(searchParams?.limit || 12),
      });

      if (type) query.set("category_type", type);
      if (searchParams?.brands) query.set("brands", searchParams.brands);
      if (searchParams?.affiliations) {
        query.set("affiliations", searchParams.affiliations);
      }

      const option = { lang: params?.lang };
      if (searchParams?.signal) option.signal = searchParams.signal;

      return await getRequest(
        `${baseUrl}${endpoints.courseSearch}?${query.toString()}`,
        option
      );
    }

    let url = "";

    if (searchParams?.brands) {
      searchParams?.brands
        .split(",")
        ?.forEach(
          (param, index) =>
            (url += `&filters[brands][slug][$in][${index}]=${param}`)
        );
    }

    if (searchParams?.affiliations) {
      searchParams?.affiliations
        .split(",")
        ?.forEach(
          (param, index) =>
            (url += `&filters[affiliations][slug][$in][${index}]=${param}`)
        );
    }

    if (type) {
      url += "&filters[category_type][slug][$eq]=" + type;
    }

    if (searchParams?.sort === "alphabets") {
      url += "&sort=course_name:asc";
    } else if (searchParams?.sort === "new") {
      url += "&sort=createdAt:desc";
    } else if (searchParams?.sort === "popular") {
      url += "&sort=createdAt:asc";
    } else if (searchParams?.sort === "menu_showing_order") {
      url += "&sort=menu_showing_order:desc";
    }

    if (params?.showMenu) {
      url += "&filters[show_in_menu][$eq]=true";
    }

    if (searchParams?.show_on_search) {
      url += "&filters[show_on_search][$eq]=true";
    }

    url += buildPaginationQuery(searchParams);

    const option = {
      lang: params?.lang,
    };
    if (searchParams?.signal) {
      option["signal"] = searchParams?.signal;
    }

    const res = await getRequest(baseUrl + endpoints.courses + url, option);
    return res;
  } catch (error) {
    console.log(error?.message);
  }
};

export const getAllCourses = async (params) => {
  try {
    const res = await getRequest(baseUrl + endpoints.allCourses, {
      lang: params?.lang,
    });
    return res;
  } catch (error) {
    console.log(`Error fetching all courses : `, error?.message);
    return null;
  }
};

export const getAllCoursesPayNow = async (params) => {
  try {
    const res = await getRequest(baseUrl + endpoints.allCoursesPayNow, {
      lang: params?.lang,
    });
    return res;
  } catch (error) {
    console.log(`Error fetching all courses : `, error?.message);
    return null;
  }
};
